<template>
  <div class="animated fadeIn">
    <h4 class="page-title">Tribecar Reservations</h4>
    <hr >
    <SearchForm class="mb-3" @search="handleSearch" @reset="handleReset" />
    <b-row v-if="originalItems.length" class="mb-3">
      <b-col md="3">
        <b-form-group label="Transmission Status">
          <b-select
            v-model="filter.transmissionStatus"
            :options="transmissionStatuses"
            @change="handleTransmissionChange" />
        </b-form-group>
      </b-col>
    </b-row>
    <Spinner v-if="isFetching" />
    <b-alert
      :show="!isFetching && isEmpty"
      variant="danger">
      No result found
    </b-alert>
    <b-table
      v-if="!isFetching && items.length"
      :items="items"
      :fields="fields"
      :per-page="itemsPerPage"
      :current-page="currentPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      responsive
      hover>
        <template v-slot:cell(reservationStart)="{ item }">
          {{ item.reservationStart | date }}
        </template>
        <template v-slot:cell(reservationEnd)="{ item }">
          {{ item.reservationEnd | date }}
        </template>
         <template v-slot:cell(action)="{ item }">
           <b-btn
            variant="success"
            size="sm"
            @click="handleView(item)">
             View
           </b-btn>
        </template>
      </b-table>
      <b-pagination
        v-show="items.length > 10"
        :total-rows="items.length"
        :per-page="itemsPerPage"
        v-model="currentPage" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import Spinner from '@/components/Spinner'
import SearchForm from './SearchForm'
import { toastr } from '@/services'

export default {
  name: 'TribecarReservations',
  components: {
    SearchForm,
    Spinner
  },
  data() {
    return {
      itemsPerPage: 10,
      currentPage: 1,
      items: [],
      originalItems: [],
      isFetching: false,
      isEmpty: false,
      sortBy: 'reservationStart',
      sortDesc: true,
      fields: [
        'reservationId',
        'licensePlate',
        {
          key: 'reservationStart',
          sortable: true,
        },
        {
          key: 'reservationEnd',
          sortable: true
        },
        'transmissionStatus',
        'action'
      ],
      filter: {
        transmissionStatus: 'all'
      },
      transmissionStatuses: [
        { value: 'all', text: 'All' },
        { value: 'Error', text: 'Error' },
        { value: 'NoError', text: 'No Error' }
      ],
    }
  },
  computed: {
    ...mapState('cocos', ['searchForm'])
  },
  created() {
    const defaultDate = {
      reservationStart: moment().format('YYYY-MM-DD 00:00'),
      reservationEnd: moment().format('YYYY-MM-DD 23:59')
    }
    this.fetchData(defaultDate)
  },
  methods: {
    async handleSearch(payload) {
      if (payload) {
        this.$store.commit('cocos/SET_SEARCH_FORM', payload)
      }
      await this.fetchData()
      this.$router.replace({
        name: 'TribecarReservations',
        query: this.searchForm
      })
    },
    fetchData(params = {}) {
      this.items = []
      this.isEmpty = false
      this.isFetching = true
      const payload = JSON.parse(JSON.stringify(this.searchForm))
      payload.partner = 'tribecar'
      return new Promise((resolve) => {
        this.$store.dispatch('cocos/getReservations', {...payload, ...params})
          .then((data) => {
            this.isFetching = false
            this.items = data
            this.originalItems = data
            if (!data.length) this.isEmpty = true
            resolve()
          })
          .catch((err) => {
            this.isFetching = false
            toastr.error(err.message)
            resolve()
          })
      })
    },
    handleView({ reservationId }) {
      this.$router.push({ name: 'TribecarFleetEvents', params: { reservationId: reservationId } })
    },
    handleReset() {
      this.items = []
      this.isEmpty = false
      this.$store.commit('cocos/RESET_SEARCH_FORM')
      this.handleSearch()
    },
    handleTransmissionChange(val) {
      if (val === 'all') {
        this.items = this.originalItems
      } else {
        this.items = this.originalItems.filter((item) => item.transmissionStatus === val)
      }
    }
  }
}
</script>

<style>

</style>